import getServiceName from '../getServiceName';
const csrfTokens = {};
const defaultAttemptLimit = 3;
export const addCsrfHeader = config => {
  const serviceName = getServiceName(config);
  if (serviceName && csrfTokens[serviceName]) {
    const token = csrfTokens[serviceName];
    config.headers[token.headerName] = token.value;
  }
  return config;
};
export const captureCsrfHeader = response => {
  const config = response.config;
  const serviceName = getServiceName(config);

  // Only capture if we don't have a token already.
  if (serviceName && !csrfTokens[serviceName]) {
    // Axios uses lowercase for header names
    const csrfHeaderName = response.headers['x-csrf-header'];
    const csrfToken = csrfHeaderName ? response.headers[csrfHeaderName.toLowerCase()] : null;

    // Not all responses include a token. Avoid updating token to null.
    if (csrfToken) {
      csrfTokens[serviceName] = {
        headerName: csrfHeaderName,
        value: csrfToken
      };
    }
  }
  return response;
};
export const createCsrfRetryHandler = axios => err => {
  const status = err.response?.status;
  const is403ForCsrf = status === 403 && err.response?.headers['x-forbidden-reason'] === 'CSRF';
  const is401ForCsrf = status === 401 && err.response?.headers['x-unauthorized-reason'] === 'POSSIBLE_CSRF';
  if (!is403ForCsrf && !is401ForCsrf && status !== 449) {
    return Promise.reject(err);
  }
  const serviceName = getServiceName(err.config);
  if (!serviceName) {
    return Promise.reject(err);
  }
  const csrfHeaderName = err.response?.headers['x-csrf-header'];
  // Lowercase the header name because Axios makes all headers lowercase
  const csrfToken = csrfHeaderName ? err.response?.headers[csrfHeaderName.toLowerCase()] : null;

  // Not all CSRF responses include the token. Avoid updating token to null.
  if (csrfToken) {
    csrfTokens[serviceName] = {
      headerName: csrfHeaderName,
      value: csrfToken
    };
  }

  // We already tried with the expected CSRF header enough times, stop retrying.
  const previousAttempts = err.config.csrfRetryCount ?? 0;
  const attemptsLimit = err.config.csrfRetryLimit ?? defaultAttemptLimit;
  if (previousAttempts >= attemptsLimit) {
    return Promise.reject(err);
  }

  // Without a CSRF token there is no point in retrying.
  if (!csrfTokens[serviceName]) {
    return Promise.reject(err);
  }
  err.config.csrfRetryCount = previousAttempts + 1;

  // The service throttle interceptor can prevent the follow CSRF call from completing because
  // the interceptor is waiting for this failed request to complete. Overriding the throttle
  // lets this request through while still preventing the other queued requests from going out.
  err.config.disableNovaServiceThrottle = true;
  return axios.request(err.config);
};
//# sourceMappingURL=csrf.js.map